import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  .thumbnail {
    border-radius: 8px;
    width: 62px;
    height: 62px;
  }
  .active-thumbnail {
    border: 1px solid ${color.orange1};
  }
  .prev,
  .next {
    font-weight: normal;
    font-size: 14px;
    padding: 8px;
    margin-top: -14px;
    padding: 1px 10px;
    border-radius: 30px;
  }
  a.prev:hover,
  a.next:hover {
    color: ${color.orange3};
  }
`;

export default Wrapper;
